import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_ENDPOINT_STARTER;

const getCalendarData = async ()=> {
    return axios.get(API_URL + 'calendar', { headers: await authHeader() });
  }

export{
    getCalendarData
}


